export const DEFAULT_ANGLE_REF = 2.0;
